import Identified from "@mapmycustomers/shared/types/base/Identified";

const typedIdGetter = <T>({ id }: Identified<T>, type?: string): string =>
  type ? `${type}:${id}` : `${id}`;

export default typedIdGetter;
